module.exports = __webpack_public_path__ + "img/doc-xs@2x.e2b717d9.jpg";